import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Boards, IBoards, Member, tSharedAppState } from 'common/modules/ReactShared';
import { IParams } from './types';

const initialState: IBoards = {
  boards: [],
  meta: {
    allAuthors: [],
    allTeamGroups: []
  },
  boardsCount: 0,
  currentPage: 1,
  totalPages: 0,
  nextPage: null,
  prevPage: null,
  limitValue: 25,
  totalCount: 0
};

const getBoards = createAsyncThunk<IBoards, IParams | undefined>(
  'boards/getBoards_request',
  async (params) => {
    const data = await Boards.boardsApi.getBoards({
      searchValue: params?.searchValue,
      authorId: params?.authorId,
      teamGroupId: params?.teamGroupId
    });
    return data;
  }
);

const getBoardsMore = createAsyncThunk<
  IBoards | null,
  IParams | undefined,
  { state: tSharedAppState }
>('boards/getBoardsMore_request', async (params, { getState }) => {
  const pageNumber = Member.selectors.selectBoardsStore(getState())?.nextPage;
  if (!pageNumber) {
    return null;
  }

  const data = await Boards.boardsApi.getBoards({
    page: pageNumber,
    searchValue: params?.searchValue,
    authorId: params?.authorId,
    teamGroupId: params?.teamGroupId
  });
  return data;
});

const boardsSlice = createSlice({
  name: 'boards',
  initialState: initialState as IBoards,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getBoards.fulfilled, (_, action) => {
      return action.payload;
    });

    builder.addCase(getBoardsMore.fulfilled, (state, action) => {
      const { payload } = action;
      if (payload) {
        return {
          ...payload,
          meta: payload.meta ?? state.meta,
          boards: [...state.boards, ...payload.boards]
        };
      }
      return state;
    });
  }
});

const { reducer } = boardsSlice;

const actions = {
  getBoards,
  getBoardsMore
};

export { reducer, actions };
